<template>
	<div class="login container">
		<div class="header"><img :src="$store.state.config.header" class="img"></div>
		<div class="content">
			<div class="main-body">
				<div class="main-wrapper">
					<div class="main-content login-content">
						<p class="text-intro">用户登录</p>
						<div class="form-control">
							<input type="text" placeholder="用户名" v-model="userName">
						</div>
						<div class="form-control">
							<input type="password"  placeholder="密码" v-model="password">
						</div>
						<div class="form-control submit-btn">
							<button @click="login" :style="{backgroundColor: $store.state.config.button_color}">登录</button>
						</div>
						<div class="footer"><img :src="$store.state.config.footer"></div>
					</div>
				</div>
			</div>
		</div>
    <v-loading v-show="status"></v-loading>
	</div>
</template>

<script>
import {ajax} from 'jquery'

import Load from '@/components/Loading'

export default{
  components: {
    'v-loading': Load
  },
	data() {
		return {
			status: false,
			userName:'',
			password: '',
  		page_status: true,
  		not_height: '100%'
		}
	},
	methods: {
		login() {
			let that = this;

			if(that.userName == ''|| that.password == '') {
				alert('用户名或密码不能为空。');
				return false;
			}

			that.status = true;
			ajax({
				type: 'post',
				url: that.$store.state.Host+'/v/user/check_account',
				data: {tt: that.$route.query.tt, account: that.userName, password: that.password},
				success: function(res) {
					if(res.result != 1)  {
						alert('用户名或密码错误。');
					} else {
						that.$store.dispatch('saveUser', {userId: that.userName, status: true});
						that.$router.push({path: '/', query: {tt: that.$route.query.tt}});
					}

					that.status = false;
				},
				error: function(err, data) {
					if(err.status == 404) {
						setTimeout(function() {
							that.page_status = false;
							that.not_height = window.innerHeight + 'px';
						}, 3000);
						console.log('找不到');
					}
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/Login.vue